import { Injectable } from "@angular/core";

import { CoreState } from "../state";

import { AamsTransaction, GameRound } from "./aams-data.model";

@Injectable({
	providedIn: "root",
})
export class AamsDataSelector {
	getLastGameRound() {
		return (state: CoreState): GameRound | undefined => state.aamsData.lastGameRound;
	}

	getTransactions() {
		return (state: CoreState): AamsTransaction | undefined => state.aamsData.transactions;
	}

	getSessions() {
		return (state: CoreState): AamsTransaction | undefined => state.aamsData.sessions;
	}
}
